<template>
  <Card class="combobox-card">
    <div v-show="chips.length == 0" class="combobox-img">
      <div class="mt-4">{{ $t('Please select String Inverters in order to check the graph') }}</div>
      <div class="mt-4">
      <img src="../../assets/selectOption.svg" alt="choose" height="80px" width="80px">
      </div>
    </div>
    <div v-show="localChips.length > 0">
      <v-chip v-for="(chip, index) in localChips" :key="index" @input="() => remove(chip)" :selected="true" :color="colors[index]" small close>
        <strong class="white--text">{{ chip }}</strong>
      </v-chip>
    </div>
  </Card>
</template>

<script>
import { colorMixin } from '@/util/mixin/index.js'

export default {
  mixins: [ colorMixin ],
  props: {
    chips: Array
  },
  data: () => ({
    localChips: []
  }),
  mounted() {
    this.localChips = [...this.chips]
  },
  methods: {
    remove(item) {
      let index = this.localChips.indexOf(item)
      this.localChips.splice(index, 1)
      this.localChips = [...this.localChips]
      this.dataLength = this.localChips.length
      this.$emit('aleterSelectedChannels', this.localChips)
    }
  },
  watch: {
    chips() {
      this.dataLength = this.chips.length
      this.localChips = [...this.chips]
    }
  }
}
</script>
<style scoped>
.combobox-card {
  height: calc(100vh - 335px);
  overflow-x: hidden;
  overflow-y: auto;
}

.combobox-img {
  text-align: center;
}
</style>
